module.exports = __webpack_public_path__ + "static/media/HP-LoginImage-Mobile-@2x.ef28219f.png";